import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import { CoverImagePicker } from '@/components/help_center/CoverImagePicker'
import type { HelpArticleFull, HelpCategoryNode } from '@/pages/HelpCenter/types'

interface ArticleCoverCardProps {
  article: HelpArticleFull
  categories: HelpCategoryNode[]
  categoryId: string
  brandPrimary: string | null
  brandAccent: string | null
}

export function ArticleCoverCard({ article, categories, categoryId, brandPrimary, brandAccent }: ArticleCoverCardProps) {
  return (
    <Card>
      <CardHeader><CardTitle className="text-base">Cover image</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs text-muted-foreground">Shown on cards and at the top of the article. Optional.</p>
        <CoverImagePicker
          resource="help_article"
          id={article.id}
          currentUrl={article.feature_image_url}
          cover={article.cover}
          brandPrimary={brandPrimary}
          brandAccent={brandAccent}
          defaultIcon={categories.find(c => c.id === categoryId)?.icon ?? null}
        />
      </CardContent>
    </Card>
  )
}
